import React from 'react';

export const RETENTION_FAQ = [
  {
    label: "Can you tell me more about Retention.com's cost? ",
    children: (
      <>
        <p>
          Retention.com uses a tiered pricing model, starting at $500 per month
          for its basic "Startup Plan". Custom pricing is available for
          enterprise-level plans targeting higher revenue but costs can quickly
          escalate as traffic and contact lists grow. Annual commitments are
          typically required, and access to advanced features like "Grow" and
          "Reclaim" may come with additional costs.
        </p>
        <p>
          In comparison, Customers.ai offers a much more affordable pricing
          structure, starting at just $99 per month and going up to $399 +
          contact fees. This transparent, scalable pricing includes all premium
          features, giving you the flexibility to grow without breaking the
          bank.
        </p>
      </>
    ),
  },
  {
    label: 'What do Retention.com reviews say about the platform?',
    children: (
      <p>
        Here's what users are saying in their Retention.com reviews: Some users
        have reported a lift in email revenue however, there are concerns about
        the engagement quality of contacts added through the "grow" tool, as
        they may not be as engaged as regular subscribers. Other users report
        deliverability and sending issues due to spam complaints.
      </p>
    ),
  },
  {
    label: "Who are Retention.com's competitors?",
    children: (
      <p>
        Retention.com's main competitors include platforms like Customers.ai,
        Opensend, and RevenueRoll. While Retention focuses on basic data
        collection and outreach, competitors like Customers.ai provide advanced
        segmentation, automation, and actionable insights that help businesses
        drive more conversions and maximize ROI.
      </p>
    ),
  },
  {
    label: 'Does Retention.com integrate with Klaviyo?',
    children: (
      <p>
        Yes, Retention.com integrates with Klaviyo. However, Customers.ai offers
        more advanced segmentation, data enrichment, and resignaling
        capabilities. While Retention.com connects your anonymous visitor data
        to Klaviyo, Customers.ai gives you the power to run various campaigns
        with richer audience insights and stronger retargeting options.
      </p>
    ),
  },
  {
    label: 'Does Retention.com have an API?',
    children: (
      <p>
        No, Retention.com's so-called “API” is limited to some additional
        call-back functions on their main pixel - for example, sending back
        suppression data. It's not an actual API from the sense of having the
        ability to integrate it into your code or product.
      </p>
    ),
  },
  {
    label: 'Does Retention.com integrate with Shopify?',
    children: (
      <p>
        Yes, Retention.com integrates with Shopify, however, for more advanced
        segmentation and automation features, tools like Customers.ai may offer
        a more robust solution tailored to ecommerce marketers. Additionally,
        Customers.ai is the only official visitor identification app in the
        Shopify app store.
      </p>
    ),
  },
  {
    label: 'Is Retention.com legal?',
    children: (
      <p>
        Yes, just like Customers.ai, Retention.com operates within legal
        frameworks. However, it's important for businesses using Retention.com,
        or any visitor identification software, to ensure they comply with
        relevant laws. Many users have complained about their emails getting
        blocked and even getting kicked off of Active Campaign.
      </p>
    ),
  },
];

export const OPENSEND_FAQ = [
  {
    label: "Can you tell me more about Opensend's pricing model? ",
    children: (
      <p>
        Opensend operates on a tiered pricing model, charging more for advanced
        features and higher contact volumes, making it potentially costly for
        growing businesses. In contrast, Customers.ai offers all premium
        features at a single price, without any hidden fees or additional costs.
      </p>
    ),
  },
  {
    label: 'What do Opensend reviews say about the platform?',
    children: (
      <p>
        Here's what users are saying in their Opensend reviews: While some users
        appreciate its basic lead capture functionality, many reviews mention
        limitations in data accuracy and segmentation options. Users often
        highlight a desire for more robust tools and better customer support to
        help maximize their marketing efforts.
      </p>
    ),
  },
  {
    label: "Who are Opensend's competitors?",
    children: (
      <p>
        Opensend's main competitors include platforms like Customers.ai,
        Retention, and ActiveCampaign, all of which offer more comprehensive
        lead capture and marketing automation tools. While Opensend focuses on
        basic data collection, these competitors provide advanced segmentation,
        automation, and actionable insights that help businesses drive more
        conversions and maximize ROI.
      </p>
    ),
  },
  {
    label: 'Does Opensend integrate with Klaviyo?',
    children: (
      <p>
        Yes, Opensend integrates with Klaviyo, allowing users to sync visitor
        data and enhance automated email flows like abandoned cart sequences.
        However, Customers.ai offers more advanced segmentation and
        personalization capabilities, helping marketers take more precise
        actions based on visitor behavior. While Opensend connects data,
        Customers.ai empowers businesses to optimize campaigns with richer
        audience insights and stronger retargeting options.
      </p>
    ),
  },
  {
    label: 'Does Opensend have an API?',
    children: (
      <p>
        Yes, Opensend provides an API that allows developers to integrate its
        lead capture and visitor identification functionality with other
        systems. The API enables custom workflows and data syncing between
        Opensend and other marketing tools.
      </p>
    ),
  },
  {
    label: 'Does Opensend integrate with Shopify?',
    children: (
      <p>
        Yes, Opensend integrates with Shopify, allowing users to capture visitor
        data and enhance their marketing efforts within the Shopify platform.
        However, for more advanced segmentation and automation features, tools
        like Customers.ai may offer a more robust solution tailored to ecommerce
        marketers.
      </p>
    ),
  },
  {
    label: 'Is Opensend legal?',
    children: (
      <p>
        Yes, just like Customers.ai, Opensend operates within legal frameworks.
        However, it's important for businesses using Opensend, or any lead
        capture software, to ensure they comply with relevant laws based on
        their specific use case and region.
      </p>
    ),
  },
];
